// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function Register() {
  const [form, setForm] = useState({ name: "", email: "", password: "", role: "supporter" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const r = await register(form);
    setLoading(false);
    if (r.ok) navigate("/dashboard", { replace: true });
    else setError(r.error);
  };

  const googleSignIn = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-[80vh] grid grid-cols-1 md:grid-cols-2" data-testid="register-page">
      <div className="flex items-center justify-center py-20 px-6 order-2 md:order-1">
        <div className="w-full max-w-md">
          <div className="overline">Create an account</div>
          <h1 className="font-display text-4xl md:text-5xl mt-3">Join the community.</h1>

          <button onClick={googleSignIn} className="mt-8 w-full h-12 border border-foreground flex items-center justify-center gap-3 hover:bg-foreground hover:text-background transition-colors" data-testid="google-signup-btn">
            <span className="text-sm tracking-wide">Sign up with Google</span>
          </button>

          <div className="my-8 flex items-center gap-3 text-xs text-foreground/50">
            <div className="flex-1 h-px bg-border" />
            <span>or with email</span>
            <div className="flex-1 h-px bg-border" />
          </div>

          <form onSubmit={submit} className="space-y-4" data-testid="register-form">
            <input required placeholder="Full name" value={form.name} onChange={set("name")} className="w-full h-12 px-4 border border-border bg-background outline-none focus:border-primary" data-testid="register-name" />
            <input required type="email" placeholder="Email" value={form.email} onChange={set("email")} className="w-full h-12 px-4 border border-border bg-background outline-none focus:border-primary" data-testid="register-email" />
            <input required type="password" placeholder="Password (min 6 characters)" value={form.password} onChange={set("password")} className="w-full h-12 px-4 border border-border bg-background outline-none focus:border-primary" data-testid="register-password" />
            <select value={form.role} onChange={set("role")} className="w-full h-12 px-4 border border-border bg-background outline-none focus:border-primary" data-testid="register-role">
              <option value="supporter">I'm a supporter / fan</option>
              <option value="sponsor">I represent a corporate sponsor</option>
            </select>
            <p className="text-xs text-foreground/60">Golfers must apply via <Link to="/apply" className="text-primary hover:underline">/apply</Link>. Profiles are activated after review.</p>
            {error && <div className="text-sm text-destructive" data-testid="register-error">{error}</div>}
            <button disabled={loading} className="btn-primary w-full" data-testid="register-submit">
              {loading ? "Creating account…" : "Create account"}
            </button>
          </form>

          <div className="mt-6 text-sm text-foreground/60">
            Already have an account? <Link to="/login" className="text-primary hover:underline" data-testid="login-link">Sign in</Link>
          </div>
        </div>
      </div>

      <div className="hidden md:block relative border-l border-border order-1 md:order-2">
        <img src="https://images.unsplash.com/photo-1591491640784-3232eb748d4b" alt="Golfer" className="absolute inset-0 w-full h-full object-cover image-mono" />
        <div className="absolute inset-0 bg-gradient-to-t from-background/80 via-background/20 to-transparent" />
        <div className="absolute bottom-10 left-10 right-10">
          <div className="overline">Be part of it</div>
          <div className="font-display text-4xl mt-3">Back the <span className="text-primary">underdog</span>. Make history.</div>
        </div>
      </div>
    </div>
  );
}
